import React from 'react'

interface ValidationMessageProps {
  missingFieldLabels: string[]
  onClose?: () => void
}

const ValidationMessage: React.FC<ValidationMessageProps> = ({ 
  missingFieldLabels, 
  onClose 
}) => {
  if (missingFieldLabels.length === 0) return null

  return (
    <div className="validation-message">
      <div className="validation-message-content">
        <div className="validation-message-header">
          <h3>Uzupełnij wybory</h3>
          {onClose && (
            <button 
              className="validation-message-close" 
              onClick={onClose}
              aria-label="Zamknij"
            >
              ×
            </button>
          )}
        </div>
        <div className="validation-message-body">
          <p>Aby przejść do podsumowania, musisz wybrać następujące opcje:</p>
          <ul>
            {missingFieldLabels.map((label, index) => (
              <li key={index}>{label}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="validation-message-backdrop" onClick={onClose}></div>
    </div>
  )
}

export default ValidationMessage
